export default theme => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  header: {
    fontWeight: 600, 
    marginTop: 16, 
    marginBottom: 16
  }
});
  
